import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { useApiKeyMutations } from "#app/hooks/settings/use-api-key-mutations";
import { ApiKeyFormView } from "#app/components/settings/api-key-form-view";
import { ApiKeyView } from "#app/components/settings/api-key-view";
import type { Permissions } from "#app/components/settings/permission-badge";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { withPermission } from "#app/components/permissions/require-permission";
import type { Omittable } from "@salestrak/ui";

type CreatedKey = Omittable<{
  name: string;
  permissions: Permissions;
  creationDate?: string | null;
  secret: string;
}>;

function ApiKeyCreatePage() {
  const { replace } = useAppNavigate();
  const { createApiKey } = useApiKeyMutations();

  const [createdKey, setCreatedKey] = useState<CreatedKey | null>(null);

  const navigateBack = () => replace("/settings/api");

  async function handleSubmit(data: { name: string; permissions: Permissions }) {
    const { __typename, ...cleanPerms } = data.permissions as any;

    const result = await createApiKey({
      name: data.name,
      permissions: cleanPerms,
    });
    if (result) {
      setCreatedKey({
        name: result.name,
        permissions: data.permissions,
        creationDate: result.creationDate,
        secret: result.apiKey ?? "",
      });
    }
  }

  if (createdKey) {
    return (
      <ApiKeyView
        apiKey={createdKey}
        secret={createdKey.secret}
        onDone={navigateBack}
      />
    );
  }

  return (
    <ApiKeyFormView
      apiKey={null}
      onCancel={navigateBack}
      onSubmit={handleSubmit}
    />
  );
}

export const Route = createFileRoute("/(app)/$workspace/settings/api/keys/create")({
  component: withPermission("workspace.integrations", ApiKeyCreatePage),
});
